import { ModalContainer, SwitchAppButton } from "../../../components";
import signupSuccessfulImage from "../../../assets/images/team-diverse.png";
import { Link } from "react-router-dom";

interface IOnboardingCompletedProps {
  isModalOpen: boolean;
  closeModal: () => void;
}

export const OnboardingCompletedModal = ({
  isModalOpen,
  closeModal,
}: IOnboardingCompletedProps) => {
  return (
    <ModalContainer
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      selectorPrimaryFocus="button.cds--btn--primary"
    >
      <div className="onboarding-completed-modal col flex-container justify-content--center align-items--center">
        <img
          src={signupSuccessfulImage}
          alt="onboarding completed"
          className="onboarding-completed-image mb-5"
        />

        <h2 className="font-ctm--bold mt-5 mb-5">Onboarding Completed!</h2>

        <div className="flex-box flex-container col align-items--center justify-content--center">
          <h5>
            You have successfully completed your journey to join the SwitchApp
            family.
          </h5>

          <h6 className="text-teal font-ctm--bold mt-5">
            If you need to change something,{" "}
            <Link to="/feedback" className="switchapp-link">
              please let us know
            </Link>
            . We will also reach out if we need additional information.
          </h6>
        </div>

        <SwitchAppButton
          kind="primary"
          size="md"
          onClick={closeModal}
          className="mt-5"
        >
          Explore SwitchApp
        </SwitchAppButton>
      </div>
    </ModalContainer>
  );
};
